import apiRoutes from "startups/apiRoutes";
import {
  getData,
  submitData,
  catchHttpError,
  singleRelationshipToRequestFormat,
} from "shared/api";

export function fetchOrderUnitDetails(id) {
  return dispatch =>
    dispatch({
      type: "FETCH_ORDER_UNIT_DETAILS",
      payload: Promise.all([
        getData(apiRoutes.orderUnitDetailsPath(id)),
        getData(apiRoutes.meProductsPath()),
      ]),
    }).catch(catchHttpError);
}

// PLEASE NOTE: Keep in sync with orderUnitDetailsActions

export function addOrderUnitProduct(orderUnit, productId, productCount) {
  const orderUnitsProducts = (orderUnit.orderUnitsProducts || []).concat({
    orderUnitId: orderUnit.id,
    productId,
    productCount,
  });
  const requestData = singleRelationshipToRequestFormat(
    "orderUnits",
    "orderUnitsProducts",
    orderUnitsProducts,
  );

  return dispatch =>
    dispatch({
      type: "SUBMIT_ORDER_UNIT_DETAILS_PRODUCTS",
      payload: Promise.all([
        submitData(
          apiRoutes.updateOrderUnitProductsPath(orderUnit.id),
          requestData,
          "PUT",
        ),
      ]),
      meta: { productUpdateType: "ADD" },
    }).catch(catchHttpError);
}

export function updateOrderUnitProduct(orderUnit, productId, productCount) {
  const orderUnitsProducts = [
    ...(orderUnit.orderUnitsProducts || []).map(o => ({ ...o })), // copy
  ];

  const updatedOrderUnitProduct = orderUnitsProducts.find(oup => {
    return `${oup.productId}` === `${productId}`;
  });

  updatedOrderUnitProduct.productCount = productCount;
  const requestData = singleRelationshipToRequestFormat(
    "orderUnits",
    "orderUnitsProducts",
    orderUnitsProducts,
  );

  return dispatch =>
    dispatch({
      type: "SUBMIT_ORDER_UNIT_DETAILS_PRODUCTS",
      payload: Promise.all([
        submitData(
          apiRoutes.updateOrderUnitProductsPath(orderUnit.id),
          requestData,
          "PUT",
        ),
      ]),
      meta: { productUpdateType: "UPDATE" },
    }).catch(catchHttpError);
}

function failBecauseEmpty() {
  return dispatch =>
    dispatch({
      type: "SUBMIT_ORDER_UNIT_DETAILS_PRODUCTS",
      payload: Promise.all([
        Promise.reject({
          response: {
            status: 422,
            data: {
              errors: [
                {
                  code: "EMPTY_REQUEST",
                  detail:
                    "Du kannst nicht das letzte Produkt einer Bestelleinheit entfernen",
                },
              ],
            },
          },
        }),
      ]),
    }).catch(() => {});
}

export function removeOrderUnitProduct(orderUnit, productId) {
  const orderUnitsProducts = (orderUnit.orderUnitsProducts || []).filter(
    oup => {
      return `${oup.productId}` !== `${productId}`;
    },
  );

  if (orderUnitsProducts.length === 0) {
    return failBecauseEmpty();
  }

  const requestData = singleRelationshipToRequestFormat(
    "orderUnits",
    "orderUnitsProducts",
    orderUnitsProducts,
  );

  return dispatch =>
    dispatch({
      type: "SUBMIT_ORDER_UNIT_DETAILS_PRODUCTS",
      payload: Promise.all([
        submitData(
          apiRoutes.updateOrderUnitProductsPath(orderUnit.id),
          requestData,
          "PUT",
        ),
      ]),
      meta: { productUpdateType: "REMOVE" },
    }).catch(catchHttpError);
}

export function requestOrderUnitApproval(orderUnitId) {
  return dispatch =>
    dispatch({
      type: "SUBMIT_ORDER_UNIT_DETAILS_REQUEST_APPROVAL",
      payload: Promise.all([
        submitData(apiRoutes.orderUnitApprovalPath(orderUnitId), {}, "PUT"),
      ]),
    }).catch(catchHttpError);
}
